export enum NumberGridType {
  MAIN = 'MAIN',
  MINI_GAME = 'MINI_GAME',
}
